/**
 * Created by Jerker Nord on 2020-03-31.
 */
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {TimelineLite} from "gsap";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {MonkeysGoldGameConfig} from "../../MonkeysGoldGameConfig";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {MonkeysGoldReelSymbol} from "../../symbols/MonkeysGoldReelSymbol";
import {INolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {MonkeysGoldSoundConfig} from "../../MonkeysGoldSoundConfig";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";

export class MonkeysGoldSymbolUpgradeView extends BaseView {

    private _spineSymbols1x1:PIXI.spine.Spine[][];
    private _symbols:string[] = ["L5", "L4", "L3", "L2", "L1", "M5", "M4", "M3", "M2", "M1", "M1_2", "M1_3", "M1_4", "M1_5", "M1_6", "M1_7"];

    constructor() {
        super();
        StageManager.getLayer(MonkeysGoldGameConfig.instance.LAYERS.WIN_PRESENTATIONS.name).addChild(this);
    }

    protected initAnimations():void {
        this._spineSymbols1x1 = [];

        //Create and position the 1x1 spine turn symbols
        for(let i:number = 0; i < 6; i++) {
            const reel:PIXI.spine.Spine[] = [];
            for(let j:number = 0; j < 6; j++) {
                const spineSymbol:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("spineSymbolTurn1x1"));
                spineSymbol.position = new PIXI.Point(Helper.getSymbolPositions(i, j)[0], Helper.getSymbolPositions(i, j)[1]);
                spineSymbol.visible = false;
                this.addChild(spineSymbol);
                reel.push(spineSymbol);
            }
            this._spineSymbols1x1.push(reel);
        }
    }

    public get1x1TurnAnimation(upgradePositions:boolean[][], upgradeSymbols:string[][], reels:string[][]):TimelineLite {
        const allSymbolsTurnMainTL:TimelineLite = new TimelineLite();
        allSymbolsTurnMainTL.add(new TimelineLite({delay : 0.1}));

        let numberOfUpgrades:number = 1;
        let tempNumberOfUpgrades:number;
        for(let i:number = 0; i < upgradePositions.length; i++) {
            for(let j:number = 0; j < upgradePositions[i].length; j++) {
                if(upgradePositions[i][j] == true) {
                    tempNumberOfUpgrades = this._symbols.indexOf(upgradeSymbols[i][j]) - this._symbols.indexOf(reels[i][j]);
                    if (tempNumberOfUpgrades > numberOfUpgrades){
                        numberOfUpgrades = tempNumberOfUpgrades;
                    }
                }
            }
        }

        for(let k:number = 0; k < numberOfUpgrades; k++) {
            allSymbolsTurnMainTL.add(() => (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.SYMBOLS_UPGRADE)}));
            const allSymbolTurnAnimations:TimelineLite[] = [];
            for(let i:number = 0; i < upgradePositions.length; i++) {
                for(let j:number = 0; j < upgradePositions[i].length; j++) {
                    if(upgradePositions[i][j] == true) {
                        //If symbol has upgraded to it's target sym, it should not upgrade more
                        if(this._symbols[this._symbols.indexOf(reels[i][j]) + k] == upgradeSymbols[i][j]) {
                            upgradePositions[i][j] = false;
                        } else {
                            const allSymbolTurnAnimation:TimelineLite = new TimelineLite();
                            allSymbolTurnAnimation.add(() => this._spineSymbols1x1[i][j].updateTransform());
                            allSymbolTurnAnimation.add(() => this._spineSymbols1x1[i][j].visible = true, "+=" + (i * 0.05));
                            allSymbolTurnAnimation.add(() => this._spineSymbols1x1[i][j].skeleton.setSkin(null));
                            allSymbolTurnAnimation.add(() => this._spineSymbols1x1[i][j].skeleton.setSkinByName(this.getSkinName(this._symbols[this._symbols.indexOf(reels[i][j]) + 1 + k])));
                            allSymbolTurnAnimation.add(() => this._spineSymbols1x1[i][j].skeleton.setSlotsToSetupPose());
                            allSymbolTurnAnimation.add(new SpineTween(this._spineSymbols1x1[i][j], 0, "All symbols turn1x1", 0));

                            allSymbolTurnAnimations.push(allSymbolTurnAnimation);
                        }
                    }
                }
            }
            allSymbolsTurnMainTL.add(allSymbolTurnAnimations, "+=0.2");
        }

        return allSymbolsTurnMainTL;
    }

    private replaceSymbol(reel:number, row:number, symName:string):void {
        Reels.getReel(reel)!.allSymbols[row].replaceWith(symName, reel);
    }

    public abort(reels:string[][]):void {
        for(let i:number = 0; i < 6; i++) {
            let symbolsOnReel:StateReelSymbol[] = Reels.getReel(i)!.allSymbols;
            if(symbolsOnReel) {
                for(let j:number = 0; j < symbolsOnReel.length; j++) {
                    if(symbolsOnReel[j].symName.indexOf("colossalx2") > -1 || symbolsOnReel[j].symName.indexOf("colossalx3") > -1) {
                        symbolsOnReel[j].replaceWith((<MonkeysGoldReelSymbol>symbolsOnReel[j]).originalSymName + symbolsOnReel[j].symName.slice(2, symbolsOnReel[j].symName.length), symbolsOnReel[j].reelId);
                    }
                }
            }
        }

        for(let i:number = 0; i < this._spineSymbols1x1.length; i++) {
            for(let j:number = 0; j < this._spineSymbols1x1[i].length; j++) {
                if(this._spineSymbols1x1[i][j].visible == true) {
                    this.replaceSymbol(i, j, reels[i][j]);
                    this._spineSymbols1x1[i][j].visible = false;
                }
            }
        }
    }

    private getSkinName(targetSym:string):string {
        switch(targetSym) {
            case "M1_7":
                return "mx6_to_mx7";
            case "M1_6":
                return "mx5_to_mx6";
            case "M1_5":
                return "mx4_to_mx5";
            case "M1_4":
                return "mx3_to_mx4";
            case "M1_3":
                return "mx2_to_mx3";
            case "M1_2":
                return "m1_to_mx2";
            case "M1" :
                return "m2_to_m1";
            case "M2" :
                return "m3_to_m2";
            case "M3" :
                return "m4_to_m3";
            case "M4" :
                return "m5_to_m4";
            case "M5" :
                return "l1_to_m5";
            case "L1" :
                return "l2_to_l1";
            case "L2" :
                return "l3_to_l2";
            case "L3" :
                return "l4_to_l3";
            case "L4" :
                return "l5_to_l4";
            default :
                return "";
        }
    }
}